import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const LoadingPage = () => {
  return <Spin indicator={<LoadingOutlined style={{ margin: 20, fontSize: 24 }} spin />} />;
};

export default LoadingPage;
